import React, { useState } from 'react';
import Modal from 'react-modal';
import styles from './styles.module.scss';
import TinkoffWidget from './TinkoffDonationWidget/TinkoffDonationWidget';
import close from '@app/ui/header/assets/close.svg';
import { useTranslation } from 'react-i18next';
import Rocket from './assets/rocket.svg?react';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';

Modal.setAppElement('#root');

type Props = {
    className?: string;
    onClick?: () => void;
};

export const Donate: React.FC<Props> = ({ className, onClick }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation('donate');
    const navigate = useNavigate();

    const isNewDonateEnable = process.env.ENABLE_DONATE === 'true';

    const openModal = () => {
        onClick && onClick();
        setIsOpen(true);
    };
    const closeModal = () => setIsOpen(false);

    const handleClickNewDonateBtn = () => {
        navigate('/donate');
    };

    if (isNewDonateEnable) {
        return (
            <div className={cn(styles.newDonate, className)}>
                <button className={styles.newDonateBtn} onClick={handleClickNewDonateBtn}>
                    {<Rocket />}
                    {t('button').toUpperCase()}
                </button>
            </div>
        );
    }

    return (
        <div className={className}>
            <button onClick={openModal} className={styles.Button}>
                {t('button')}
            </button>
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                className={styles.modalContent}
                overlayClassName={styles.modalOverlay}
                bodyOpenClassName={styles.modalOpen}
            >
                <button onClick={closeModal} className={styles.closeButton}>
                    <img src={close} alt={t('close')} />
                </button>
                <div className={styles.modalBody} id="tinfoffWidgenContainer">
                    <h1 className={styles.Title}>{t('title')}</h1>
                    <TinkoffWidget />
                </div>
            </Modal>
        </div>
    );
};
